import { render } from "./InputInfo.vue?vue&type=template&id=33a05a63&scoped=true"
import script from "./InputInfo.vue?vue&type=script&lang=js"
export * from "./InputInfo.vue?vue&type=script&lang=js"

import "./InputInfo.vue?vue&type=style&index=0&id=33a05a63&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a05a63"]])

export default __exports__